<div *ngIf="!isLoading" class="admission-ui-container">
    <ng-container *ngComponentOutlet="screens[activeScreenIndex].component; inputs:screens[activeScreenIndex].inputs" />
</div>